import WebService from '@util/webService';
import React, { useState, useEffect, useRef } from 'react';
import { Divider, IconButton, Select, Typography, FormControl, InputLabel, MenuItem, Checkbox, Grid } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom'

const UserPage = () => {
  const [users, set_users] = useState([])
  const navigate = useNavigate()
  const fetchUsers = async () => {
    const url = '/user'
    const resp = await WebService.get(url)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    set_users(records)
  }


  const onLoad = async () => {
    await fetchUsers()
  }

  useEffect(() => {
    onLoad()
  }, [])

  return(
    <>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography>로그인ID</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>STAT</Typography>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        {
          users?.map(user => (
            <Grid item xs={12} key={user.loginId}>
              <Grid container>
                <Grid item xs={6}>
                  <Typography style={{ cursor: 'pointer' }}
                    onClick={() => {
                      navigate(`/user/usc/${user.id}`)
                    }}
                  >{user.loginId}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography style={{cursor:'pointer'}}
                    onClick={() => {
                      navigate(`/user/wallet/${user.id}`)
                    }}
                  >{user.statusCode}</Typography>
                </Grid>
              </Grid>
            </Grid>
          ))
        }
      </Grid>

    </>
  )
}

export default UserPage
